/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

import PaymentRepository from '../../repositories/Admin/Memberships/PaymentRepository';
import { createRestSlice } from '../../utils/RestSlice';

const paymentsRestSlice = createRestSlice({
  resource: 'payments',
  repository: PaymentRepository,
  slices: ['loadPayments'],
});

const initialState = {
  ...paymentsRestSlice.initialState,
};

const paymentsSlice = createSlice({
  name: 'payments',
  initialState,
  reducers: {
    ...paymentsRestSlice.reducers,
  },
});

export default paymentsSlice.reducer;

export const paymentsRestHooks = paymentsRestSlice.hooks(paymentsSlice, [
  'admin',
  'PaymentsSlice',
]);
